import { PrismaClassifiedPipelineErrorDto } from 'app/API';

type TProps = {
  classifiedErrors?: PrismaClassifiedPipelineErrorDto[];
  openUpdateErrorDescriptionModal: (id: string) => void;
};

export const UnhandledErrorsSection = ({ classifiedErrors, openUpdateErrorDescriptionModal }: TProps) => (
  <div className="bg-[var(--color-surface)] shadow-[0_8px_10px_rgba(0,0,0,0.05)] rounded-[10px] p-5 mb-5 w-full">
    <div className="text-[var(--color-text-muted)] font-medium text-lg leading-[150%] mb-4">
      Unhandled Pipeline Errors
    </div>
    <div className="overflow-y-auto ">
      {!classifiedErrors?.length ? (
        <div className="p-2.5">No unhandled errors</div>
      ) : (
        classifiedErrors.map((classifiedError: PrismaClassifiedPipelineErrorDto) => {
          const aiConclusion = classifiedError.aiConclusion?.length
            ? JSON.parse(classifiedError.aiConclusion)
            : classifiedError.aiConclusion;

          return (
            <div
              key={classifiedError.id}
              className="p-2.5 last:border-b-0 hover:bg-[var(--color-surface-muted)] rounded-xl"
            >
              <div
                className="text-[var(--color-text-muted)] text-xs underline cursor-pointer"
                onClick={() => openUpdateErrorDescriptionModal(classifiedError.id)}
              >
                Job ID: {classifiedError.jobId}
              </div>
              <div className="text-[var(--color-text-muted)] text-xs mt-1">
                AI decision: {aiConclusion?.retryable?.toString() ?? 'n/a'}
              </div>
              <div className="text-[var(--color-error-heading)] text-xs mt-1">{aiConclusion?.conclusionText}</div>
            </div>
          );
        })
      )}
    </div>
  </div>
);
